import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import useUiuxStore from 'src/store/useUiuxStore';
import { useHRM1040_R01Store } from './Store_HRM1040_R01';

/**
 * 사업장·부서·재직상태·사원 검색 조건을 표시한다.
 * @returns 검색 조건 입력 영역 JSX
 */
export const HRM1040_R01SearchSection = () => {
    // 화면 Store에서 현재 검색 조건과 변경 함수를 가져온다.
    const { HRM1040_R01Filter, setHRM1040_R01Filter } = useHRM1040_R01Store();
    // 앱 초기화 때 읽어 둔 사업장·부서·재직상태 공통코드 목록을 가져온다.
    const { compCdList, orgCdList, empstsCdList } = useCommonCodeStore();
    /** 공통 사원 검색 팝업을 열고 선택한 사번·이름을 검색 조건에 기록한다. */
    const { setCodeSearchModalProps } = useUiuxStore();
    const openEmployeeSearch = (search: string) => {
        setCodeSearchModalProps({
            category: '사원',
            search,
            formName: 'HRM1040_R01',
            isInfo: false,
            handleFoucsId: 'HRM1040_R01-employee-search',
            onConfirm: employee => setHRM1040_R01Filter({
                keyword: employee?.empNo || '',
                empNm: employee?.empNm || '',
            }),
            processType_focus: 'normal',
        });
    };
    return (
        <SearchSectionForm>
            <SearchDropDownForm
                label="사업장"
                value={HRM1040_R01Filter.compCd}
                optionList={compCdList}
                onChangeItem={item => setHRM1040_R01Filter({ compCd: item?.compCd || '' })}
            />
            <SearchDropDownForm
                label="부서"
                value={HRM1040_R01Filter.orgCd}
                optionList={orgCdList}
                onChangeItem={item => setHRM1040_R01Filter({ orgCd: item?.orgCd || '' })}
            />
            <SearchDropDownForm
                label="재직상태"
                value={HRM1040_R01Filter.empSts}
                optionList={empstsCdList}
                onChangeItem={item => setHRM1040_R01Filter({ empSts: item?.minorCd || '' })}
            />
            <SearchCodeModalForm
                label="사원"
                value={HRM1040_R01Filter.keyword}
                valueLabel={HRM1040_R01Filter.empNm}
                onChange={event => setHRM1040_R01Filter({ keyword: event.target.value, empNm: '' })}
                onDoubleClick={event => {
                    event.currentTarget.blur();
                    openEmployeeSearch(HRM1040_R01Filter.keyword);
                }}
                onKeyDown={event => {
                    if (event.key !== 'Enter') return;
                    event.preventDefault();
                    openEmployeeSearch(HRM1040_R01Filter.keyword);
                }}
            />
        </SearchSectionForm>
    );
};
